import {ChessHistory} from "./chessHistory";

export class Board {
    scaleX;
    scaleY;
    chessPieces;
    players;
    currentPlayer;
    history;

    fieldIsUnderAttack(x, y, player) {
        return !!this.chessPieces.find(piece => {
            if (piece.player === player) {
                return false;
            }
            const positions = piece.positionsUnderAttack(this);
            return positions.find(pos => pos[0] === x && pos[1] === y);
        })
    }

    getPiece(x, y) {
        return this.chessPieces.find(piece => {
            return piece.posX === x && piece.posY === y
        });
    }

    movePiece(piece, x, y) {
        if (piece) {
            const fromX = piece.posX;
            const fromY = piece.posY;
            const success = this.movePieceWithoutHistory(piece, x, y);
            if (success) {
                this.history.write(fromX, fromY, x, y);
            }
        }
    }

    movePieceWithoutHistory(piece, x, y) {
        if (piece) {
            const targetPiece = this.getPiece(x, y);
            piece.beforeMove(this, x, y);
            if (targetPiece) {
                this.deletePiece(targetPiece);
            }
            piece.posX = x;
            piece.posY = y;
            piece.isInitialPos = false;
            let nextPlayer = this.players.indexOf(this.currentPlayer) + 1;
            if (nextPlayer >= this.players.length) {
                nextPlayer = 0;
            }
            this.currentPlayer = this.players[nextPlayer];
            return true;
        }
        return  false;
    }

    isCheck(player) {
        const mainPiece = this.getMainPiece(player);
        return mainPiece && this.fieldIsUnderAttack(mainPiece.posX, mainPiece.posY, mainPiece.player);
    }

    deletePiece(piece) {
        const index = this.chessPieces.indexOf(piece);
        this.chessPieces.splice(index, 1);
    }

    getMainPiece(player) {
        return this.chessPieces.find(piece => piece.main && piece.player === player);
    }

    availableCastlings(player) {
        const result = [];
        const castles = this.chessPieces.filter(piece => piece.castle && piece.isInitialPos && piece.player === player);
        castles.forEach(castle => {
            const relatedMain = this.getMainPiece(player);
            if (relatedMain && relatedMain.isInitialPos) {
                const pointsBetween = this.pointsBetweenPoints(castle.posX, castle.posY, relatedMain.posX, relatedMain.posY);
                const piecesBetween = pointsBetween.filter(point => this.getPiece(point[0], point[1]));
                if (piecesBetween.length === 2) {
                    result.push({
                        main: relatedMain,
                        mainMove: pointsBetween[2],
                        castle: castle,
                        castleMove: pointsBetween[1],
                    })
                }
            }
        });
        return result;
    }

    pointsBetweenPoints(x1, y1, x2, y2) {
        let fromX = Math.min(x1, x2);
        const toX = Math.max(x1, x2);
        let fromY = Math.min(y1, y2);
        const toY = Math.max(y1, y2);

        const result = [];
        let i = 0;
        do {
            result.push([Math.min(fromX + i, toX), Math.min(fromY + i, toY)]);
            i++;
        } while (fromX + i <= toX || fromY + i <= toY);
        if ((x1 > x2) !== (y2 > y1)) {
            return result;
        }
        return result.reverse();
    }

    initHistory() {
        this.history = new ChessHistory();
        this.history.init(this);
    }

    clone() {
        const result = new Board();
        result.scaleX = this.scaleX;
        result.scaleY = this.scaleY;
        result.currentPlayer = this.currentPlayer;
        result.players = [...this.players];
        result.chessPieces = this.chessPieces.map(piece => piece.clone());
        result.initHistory();
        return result;
    }

}